import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: '',
}

const filterSlice = createSlice({
  name: 'filterSlice',
  initialState: initialState,
  reducers: {
    setNameFilter: (state, action) => {
      state.name = action.payload
    },
    setComplianceFilter: (state, action) => {
      state.course_compliance = action.payload
    },
    setHvaStatusFilter: (state, action) => {
      state.hva_status = action.payload
    },
    setLocation: (state, action) => {
      state.location = action.payload
    },
    setArchived: (state, action) => {
      state.archived = action.payload
    }
  }
})

export const {setNameFilter, setComplianceFilter, setHvaStatusFilter, setLocation, setArchived} = filterSlice.actions
export const filtersReducer = filterSlice.reducer